module.exports = __webpack_public_path__ + "img/starting.87da2115.png";